import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
	palette: {
		primary: {
			main: '#4CAF50', // Green - representing the padel court
			light: '#81C784',
			dark: '#388E3C',
		},
		secondary: {
			main: '#3F51B5', // Blue - representing the padel ball
			light: '#7986CB',
			dark: '#303F9F',
		},
		background: {
			default: '#F5F5F5',
			paper: '#FFFFFF',
		},
		text: {
			primary: '#212121',
			secondary: '#757575',
		},
		error: {
			main: '#F44336',
		},
		warning: {
			main: '#FF9800',
		},
		info: {
			main: '#2196F3',
		},
		success: {
			main: '#4CAF50',
		},
	},
	typography: {
		fontFamily: "'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif",
		h1: {
			fontWeight: 700,
		},
		h2: {
			fontWeight: 600,
		},
		h3: {
			fontWeight: 600,
		},
		h4: {
			fontWeight: 600,
		},
		h5: {
			fontWeight: 600,
		},
		h6: {
			fontWeight: 600,
		},
		button: {
			fontWeight: 600,
			textTransform: 'none',
		},
	},
	shape: {
		borderRadius: 8,
	},
	components: {
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 12,
					boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					padding: '8px 16px',
				},
				contained: {
					boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						borderRadius: 8,
					},
				},
			},
		},
	},
});
